import type { PopupNotification } from "./api/schemas";
import { type Notice, notices } from "./notices";

export type PopupKind = "verification" | "tax" | "generic";
type PopupEvent = { title?: string | null; description?: string | null; code?: string | null; type?: string | null; event?: string | null; eventCode?: string | null; key?: string | number | null };

export function getPopupCode(popup: PopupEvent) {
  const values = [popup.code, popup.type, popup.event, popup.eventCode, popup.key, popup.title, popup.description].map((value) => value == null ? "" : String(value));
  return values.find((value) => value && getRestrictionKind(value)) ?? values.find((value) => value?.trim()) ?? "";
}

export function getRestrictionKind(code: string): Exclude<PopupKind, "generic"> | null {
  const value = code.trim().toLowerCase();
  if (value === "withdraw_decline_by_verif") return "verification";
  if (value === "withdraw_decline_by_tax") return "tax";
  return null;
}

export function getPopupKind(popup: PopupEvent): PopupKind {
  return getRestrictionKind(getPopupCode(popup)) ?? "generic";
}

function humanText(value: string) {
  const text = value.trim();
  return text && !/^[a-z]+(?:[_.][a-z0-9]+)+$/.test(text) ? text : "";
}

export function describePopup(popup: Pick<PopupNotification, "title" | "description"> & PopupEvent & { text?: string | null }): Notice {
  const kind = getPopupKind(popup);
  if (kind !== "generic") return notices[kind];
  const title = humanText(popup.title);
  const text = humanText(popup.text || popup.description);
  return { title: title ? { text: title } : { key: "dashboard.notice_generic_title" }, paragraphs: text ? [{ text }] : [], support: true };
}
